import sendRequest from "../../../helpers/requestHelper";
import config from "../../../config";
import eventBus from "../../../event-bus/eventBus";
import {handleError} from "../../../helpers/handleError";
import router from "../../../../router";

const paymentInvoice = {
    namespaced: true,
    state: {
        dataSaveIsFetching: false,
        textInfoInvoiceSave: "",
        typeInfoInvoiceSave: "",
        headInfoInvoiceSave: "",
        isLoading: false,
    },
    mutations: {
        DATA_SAVE_SUCCESS(state, response) {
            let dataReceive = {
                message: response.data.data.textInfo,
                title: response.data.message,
            }
            eventBus.$emit("invoicePaidAtSuccess", dataReceive);
            if (router.currentRoute.name === 'ProjectsEdit') {
                eventBus.$emit('refreshProjectData');
            }
        },
        DATA_SAVE_FAILURE(state, error) {
            state.textInfoInvoiceSave = handleError(error) !== "" ? handleError(error) : error.response.data.data.message;
            state.typeInfoInvoiceSave = "red";
            state.headInfoInvoiceSave = error.response.data.message;
            eventBus.$emit("invoicePaidAtFailure", error.response.data.errors);
        },

    },
    actions: {
        invoiceIsPaid: function({ dispatch, state }, payload) {
            let promise = sendRequest("post", config.baseURLApi + "/invoices/payment/" + payload.creds.invoice.id, {}, payload.creds);
            state.isLoading = true;
            promise.then(function(result) {
                if(result[0] === "success") {
                    dispatch("successDataSave", result[1]);
                } else {
                    dispatch("failureDataSave", result[1]);
                }
                state.isLoading = false;
            });
        },

        invoiceIsUnpaid: function({ dispatch, state }, payload) {
            let promise = sendRequest("post", config.baseURLApi + "/invoices/payment/" + payload.creds.invoice.id, {}, payload.creds);
            state.isLoading = true;
            promise.then(function(result) {
                if(result[0] === "success") {
                    dispatch("successDataSave", result[1]);
                } else {
                    dispatch("failureDataSave", result[1]);
                }
                state.isLoading = false;
            });
        },

        successDataSave: function({ commit }, response) {
            commit("DATA_SAVE_SUCCESS", response);
        },
        failureDataSave: function({ commit }, error) {
            commit("DATA_SAVE_FAILURE", error);
        },
    }
}

export default paymentInvoice;